import "./index.css";
import type { IBreadcrumbItem } from "./PageTitleProvider";
import { Skeleton, Typography } from "@/ui-kit";
import { useBreakpoints } from "@/hooks/useBreakpoints";

type IProps = {
  items: IBreadcrumbItem[];
};

export const Breadcrumbs = ({ items }: IProps) => {
  const { isMobile } = useBreakpoints();
  const allLoading = items.every((item) => item.loading);

  if (allLoading) {
    return (
      <div className="page-header__breadcrumbs">
        <Skeleton width="12.5rem" height="2.625rem" />
      </div>
    );
  }

  const filteredItems = isMobile
    ? ([items.at(-1)] as IBreadcrumbItem[])
    : items;

  const itemsJSX = filteredItems.map((item, index) => {
    const isLast = index === filteredItems.length - 1;
    return (
      <div className="page-header__breadcrumbs-item" key={item.id}>
        {item.loading ? (
          <Skeleton width="12.5rem" height="2.625rem" />
        ) : (
          <Typography
            color={isLast ? "text-primary" : "text-tertiary"}
            weight="bold"
            as="h3"
            variant={isMobile ? "h4" : "h3"}
            text={item.title}
          />
        )}
        {!isLast && (
          <Typography
            color="text-tertiary"
            weight="bold"
            as="h3"
            variant="h3"
            text="/"
          />
        )}
      </div>
    );
  });

  return <div className="page-header__breadcrumbs">{itemsJSX}</div>;
};
